window.favoriteHelpers = {

    /* ---------------------- PUBLIC API ----------------------- */

    async updateProductFavorite(vm, product) {
        if (!window.globalState.isAuth) {
            globalState.addNotification(
                "Для добавления в избранное нужно авторизоваться."
            );
            return;
        }

        const original = product.isFavorite;

        // оптимистичное обновление
        product.isFavorite = !original;

        this.debounceFavorite(vm, product, original);
    },

    /* ---------------------- DEBOUNCE -------------------------- */

    debounceFavorite(vm, product, originalState) {
        if (!vm.favoriteTimeouts) vm.favoriteTimeouts = new Map();

        clearTimeout(vm.favoriteTimeouts.get(product.id));

        const id = setTimeout(() => {
            this.sendFavoriteUpdate(product, originalState, vm);
            vm.favoriteTimeouts.delete(product.id);
        }, 300);

        vm.favoriteTimeouts.set(product.id, id);
    },

    /* ---------------------- SERVER REQUEST --------------------- */

    async sendFavoriteUpdate(product, originalState, vm) {
        try {
            const data = await this.api(window.laravelConfig.routes.updateFavorite, {
                product_id: product.id,
                is_favorite: product.isFavorite
            });

            if (!data.success) {
                // откат
                product.isFavorite = originalState;
                return;
            }

            // если мы на странице "Избранное" — удалить при снятии лайка
            if (vm.favourites && !product.isFavorite) {
                vm.favourites = vm.favourites.filter(f => f.id !== product.id);
            }

        } catch (e) {
            product.isFavorite = originalState;
        }
    },

    /* ---------------------- SHARED API -------------------------- */

    async api(url, payload) {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": window.laravelConfig.csrfToken,
                "Accept": "application/json"
            },
            body: JSON.stringify(payload)
        });

        return response.json();
    }
};
